// Подключение свайпера

import Swiper, { Navigation, Pagination, Autoplay, EffectFade } from "swiper";
// init Swiper:
const swiperAuto = new Swiper(".actual__swiper", {
  // configure Swiper to use modules
  modules: [Navigation, Pagination, Autoplay, EffectFade],
  // If we need pagination
  spaceBetween: 20,
  slidesPerView: 1.4,
  loop: true,
  autoplay: true,
  pagination: {
    el: ".swiper-pagination",
  },

  // Navigation arrows
  navigation: {
    nextEl: ".actual__swiper-btn-right",
    prevEl: ".actual__swiper-btn-left",
  },
  breakpoints: {
    584: {
      spaceBetween: 20,
      slidesPerView: 2.2,
    },

    800: {
      spaceBetween: 20,
      slidesPerView: 3.2,
    },
    1000: {
      spaceBetween: 20,
      slidesPerView: 3.4,
    },

    1200: {
      spaceBetween: 20,
      slidesPerView: 4.2,
    },
  },
});

const swiperCases = new Swiper(".cases__swiper", {
  // configure Swiper to use modules
  modules: [Navigation, Pagination, Autoplay, EffectFade],
  // If we need pagination
  spaceBetween: 20,
  slidesPerView: 1.3,
  loop: true,
  autoplay: true,
  pagination: {
    el: ".swiper-pagination",
  },

  // Navigation arrows
  navigation: {
    nextEl: ".cases__swiper-btn-right",
    prevEl: ".cases__swiper-btn-left",
  },
  breakpoints: {
    1200: {
      spaceBetween: 20,
      slidesPerView: 2.3,
    },
  },
});

const swiperCases2 = new Swiper(".cases__swiper2", {
  // configure Swiper to use modules
  modules: [Navigation, Pagination, Autoplay, EffectFade],
  // If we need pagination
  spaceBetween: 20,
  slidesPerView: 1.3,
  loop: true,
  autoplay: true,
  pagination: {
    el: ".swiper-pagination",
  },

  // Navigation arrows
  navigation: {
    nextEl: ".cases__swiper-btn-right2",
    prevEl: ".cases__swiper-btn-left2",
  },
  breakpoints: {
    1200: {
      spaceBetween: 20,
      slidesPerView: 2.3,
    },
  },
});

const swiperPhoto = new Swiper(".uslugi-photo__swiper", {
  // configure Swiper to use modules
  modules: [Navigation, Pagination, Autoplay, EffectFade],
  // If we need pagination
  spaceBetween: 20,
  slidesPerView: 2,
  // spaceBetween: 30,
  // centeredSlides: true,
  loop: true,
  autoplay: true,
  pagination: {
    el: ".swiper-pagination",
  },

  // Navigation arrows
  navigation: {
    nextEl: ".uslugi-photo-btn-right",
    prevEl: ".uslugi-photo-btn-left",
  },
  breakpoints: {
    680: {
      spaceBetween: 20,
      slidesPerView: 4,
    },
  },
});
